/* eslint-disable no-unused-vars, no-dupe-keys, react/jsx-no-duplicate-props */
// This file is auto-generated by Simple. Edit Steps/view.blocks to change it.
import * as fromDesignTokens from 'Simple/DesignTokens'
import Autodraft from './Autodraft/index'
import Downpayment from './Downpayment/index'
import Plan from './Plan/index'
import React from 'react'
import Schedule from './Schedule/index'
import Sign from './Sign/index'
import TysiaHeading from 'DesignSystem/TysiaHeading/index'
import styles from './view.module.css'



/** @type {import('Simple/types.js').View} */
export default function Steps({
  children,
  viewPath = "/App/Account/EmbeddableCoreMessageListener/TreatmentRequestOverride/Content/Steps"
  
}) {
let dtSpaceS = fromDesignTokens.useDesignTokenValue({
          viewPath,
          path: 'space.s'
        })
  return (<React.Fragment
>
<div
  data-testid="Steps.Vertical"
  data-view-path={viewPath}
 style={{'--pb-1-5MmEQ': typeof dtSpaceS === 'number' ? `${dtSpaceS}px` : dtSpaceS,'--pl-2-5MmEQ': typeof dtSpaceS === 'number' ? `${dtSpaceS}px` : dtSpaceS,'--pt-3-5MmEQ': typeof dtSpaceS === 'number' ? `${dtSpaceS}px` : dtSpaceS,'--pr-4-5MmEQ': typeof dtSpaceS === 'number' ? `${dtSpaceS}px` : dtSpaceS}}
 className={`views-block ${styles.Vertical}`}
>
<TysiaHeading
  viewPath={`${viewPath}/TysiaHeading`}
 level="h3"
 text="Steps"
/>
<Plan
  viewPath={`${viewPath}/Plan`}
/>
<Sign
  viewPath={`${viewPath}/Sign`}
/>
<Downpayment
  viewPath={`${viewPath}/Downpayment`}
/>
<Autodraft
  viewPath={`${viewPath}/Autodraft`}
/>
<Schedule
  viewPath={`${viewPath}/Schedule`}
/>
</div>
{children}
</React.Fragment>)
}